import React from 'react';
import Input from '../elements/Input';

const FuneralAndBurialWishesForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Service Type"
      value={formData.serviceType || ''}
      onChange={e => setFormData({ ...formData, serviceType: e.target.value })}
      placeholder="e.g. Hindu cremation, Christian burial, Green burial"
      error={formError.serviceType}
    />
    <Input
      label="Preferred Funeral Home"
      value={formData.funeralHome || ''}
      onChange={e => setFormData({ ...formData, funeralHome: e.target.value })}
      placeholder="e.g. Peaceful Rest, Shanti Dham, City Crematorium"
      error={formError.funeralHome}
    />
    <Input
      label="Specific Ceremony Wishes"
      type="textarea"
      value={formData.ceremonyWishes || ''}
      onChange={e => setFormData({ ...formData, ceremonyWishes: e.target.value })}
      placeholder="e.g. Play favorite song, recite Gita, white flowers only"
      error={formError.ceremonyWishes}
    />
    <Input
      label="Pre-plans / Notes"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="e.g. Prepaid with Shanti Dham, ashes to be scattered at sea"
      error={formError.notes}
    />
  </>
);

export default FuneralAndBurialWishesForm;